import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
export default Vue.extend({
    components: { WalletBar },
    name: "SendComplete",
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/send/SendComplete.vue
// module id = 655
// module chunks = 1